import React, { Component } from 'react';
import { Collapse, CardBody, Card } from 'reactstrap';
import { Link, NavLink } from 'react-router-dom';

import './style.css';

const menus = [
  {
    id: 1,
    title: 'Home',
    link: '/',
  },

  {
    id: 2,
    title: 'About',
    link: '/about',
  },

  {
    id: 3,
    title: 'Gallery',
    link: '/gallery',
  },
  {
    id: 4,
    title: 'Publications',
    link: '/publications',
  },
  {
    id: 5,
    title: 'Activities',
    link: '/',
    submenu: [
      {
        id: 54,
        title: 'Events',
        link: '/events',
      },
      {
        id: 55,
        title: 'Donate',
        link: '/donate',
      },
      {
        id: 56,
        title: 'Volunteer',
        link: '/volunteer',
      },
      {
        id: 57,
        title: 'Sponsor a Child',
        link: '/sponsored-children',
      },
      {
        id: 58,
        title: 'Blog',
        link: '/blog',
      },
    ],
  },

  // TODO: RE-ENABLE THE PAGE ONCE THERE IS A PUBLISHED ARTICLE FROM LHCF
  // {
  //   id: 6,
  //   title: "Blog",
  //   link: "/blog",
  // },

  {
    id: 7,
    title: 'Contact',
    link: '/contact',
  },
];

export default class MobileMenu extends Component {
  state = {
    isMenuShow: false,
    isOpen: 0,
  };

  menuHandler = () => {
    this.setState({
      isMenuShow: !this.state.isMenuShow,
    });
  };

  setIsOpen = (id) => () => {
    this.setState({
      isOpen: id === this.state.isOpen ? 0 : id,
    });
  };

  render() {
    const { isMenuShow, isOpen } = this.state;

    return (
      <div>
        <div className={`mobileMenu ${isMenuShow ? 'show' : ''}`}>
          <div className="close" onClick={this.menuHandler}>
            <i className="fa fa-close" aria-hidden="true"></i>
          </div>

          <ul className="responsivemenu">
            {menus.map((item) => {
              return (
                <li key={item.id}>
                  {item.submenu ? (
                    <p onClick={this.setIsOpen(item.id)}>
                      {item.title}
                      {item.submenu ? (
                        <i className="fa fa-angle-right" aria-hidden="true"></i>
                      ) : (
                        ''
                      )}
                    </p>
                  ) : (
                    <NavLink to={item.link}>{item.title}</NavLink>
                  )}
                  {item.submenu ? (
                    <Collapse isOpen={item.id === isOpen}>
                      <Card>
                        <CardBody>
                          <ul>
                            {item.submenu.map((submenu) => (
                              <li key={submenu.id}>
                                <Link to={submenu.link}>{submenu.title}</Link>
                              </li>
                            ))}
                          </ul>
                        </CardBody>
                      </Card>
                    </Collapse>
                  ) : (
                    ''
                  )}
                </li>
              );
            })}
          </ul>
        </div>

        <div className="showmenu" onClick={this.menuHandler}>
          <i className="fa fa-bars" aria-hidden="true"></i>
        </div>
      </div>
    );
  }
}
